<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import ModalAddKategoriSurvei from "./modal-add-kategori-survei.vue";
import ModalEditKategoriSurvei from "./modal-edit-kategori-survei.vue";
// import permissionService from "../../../helpers/permissionService";
import _ from "lodash";

export default {
    page: {
        title: "Kategori Survei",
        meta: [
        {
            name: "description",
            content: appConfig.description,
        },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Datatable,
        Pagination,
        ModalAddKategoriSurvei,
        ModalEditKategoriSurvei,
    },
    data() {
        let sortOrders = []; // select sortOrder

        // definisi kolom yang dipakai
        let columns = [
        {
            width: "50px",
            label: "No",
            name: "-",
        },
        {
            width: "auto",
            label: "Kategori Aspek",
            name: "kategori_aspek",
        },
        {
            width: "auto",
            label: "Deskripsi",
            name: "deskripsi",
        },
        {
            width: "200px",
            label: "Aksi",
            name: "-",
        }, // jika tidak ada sorting kasih name dengan karakter -
        ];

        // cek sorting
        columns.forEach((column) => {
        sortOrders[column.name] = -1;
        });

        // Get hak akses
        const menu = "Kategori Survei";

        return {
        title: menu,
        isWrite: localStorage.getItem("isWrite"),
        isRead: localStorage.getItem("isRead"),
        isWriteTambah: 0,
        isReadTambah: 0,
        isWriteEdit: 0,
        isReadEdit: 0,
        isWriteSetup: 0,
        isReadSetup: 0,
        isWriteDelete: 0,
        isReadDelete: 0,
        isWriteMonitor: 0,
        isReadMonitor: 0,
        showModalAdd: false,
        showModalEdit: false,
        showModalMonitor: false,
        selected_id: null,
        namePathUrl: this.$route.name,
        sessionRoleId: localStorage.session_role_active_id,
        loadingTable: true,
        table_data: [],
        columns: columns,
        sortKey: "skor", // sort key awal
        sortOrders: sortOrders,
        currentTablePage: "",

        // parsing data ke table data
        tableFilter: {
            page: 1,
            per_page: 10,
            search: "",
            column: "idkategori_survei",
            dir: "asc",
			filter_status: 1,
        },

        // config untuk paginasi
        pagination: {
            lastPage: "",
            currentPage: "",
            total: "",
            lastPageUrl: "",
            nextPageUrl: "",
            prevPageUrl: "",
            from: "",
            to: "",
            links: "",
        },
        };
    },
    async mounted() {
        // this.cekPermission("tambah", "Tambah Jadwal");
        // this.cekPermission("edit", "Edit Jadwal");
        // this.cekPermission("delete", "Delete Jadwal");
        // this.cekPermission("setup", "Setup Jadwal");
        // this.cekPermission("monitor", "Monitor Jadwal");

        await this.getDataTable();
        this.searchData = _.debounce(this.getDataTable.bind(this), 500);
    },
    methods: {
        // async cekPermission(type, permission) {
        // const data = await permissionService.getHakAkses(permission);
        // if (type == "tambah") {
        //     this.isWriteTambah = data.is_write;
        //     this.isReadTambah = data.is_read;
        // } else if (type == "edit") {
        //     this.isWriteEdit = data.is_write;
        //     this.isReadEdit = data.is_read;
        // } else if (type == "setup") {
        //     this.isWriteSetup = data.is_write;
        //     this.isReadSetup = data.is_read;
        // } else if (type == "delete") {
        //     this.isWriteDelete = data.is_write;
        //     this.isReadDelete = data.is_read;
        // } else if (type == "monitor") {
        //     this.isWriteMonitor = data.is_write;
        //     this.isReadMonitor = data.is_read;
        // }
        // },
        fullDateTimeFormat(datetime) {
        return moment(datetime).format("YYYY-MM-DD HH:mm");
        },
        async getDataTable(resetPage = true) {
			this.loadingTable = true;

			let payload = { ...this.tableFilter };

			if (resetPage) {
				this.tableFilter.page = 1; // Reset to first page when fetching new data
			}

			axios({
				method: "get",
				url:
				process.env.VUE_APP_BACKEND_URL_VERSION + "master/kategori-survei",
				params: payload,
				headers: {
				Accept: "application/json",
				Authorization: "Bearer " + localStorage.access_token,
				},
			})
				.then((response) => {
				let response_data = response.data;
				let response_data_fix = response_data.data;
				if (response_data.meta.code == 200) {
					console.log(response_data_fix);
					this.table_data = response_data_fix.data;
					this.configPagination(response_data_fix);
					this.currentTablePage = response_data_fix.current_page;
					this.loadingTable = false;
				} else {
					Swal.fire({
					icon: "error",
					title: "Oops...",
					text: response_data_fix.data.message,
					});
				}
				})
				.catch((errors) => {
				console.log(errors);
				});
		},
        configPagination(data) {
        let self = this;
        self.pagination.lastPage = data.last_page;
        self.pagination.currentPage = data.current_page;
        self.pagination.total = data.total;
        self.pagination.lastPageUrl = data.last_page_url;
        self.pagination.nextPageUrl = data.next_page_url;
        self.pagination.prevPageUrl = data.prev_page_url;
        self.pagination.from = data.from;
        self.pagination.to = data.to;
        self.pagination.links = data.links;
        },
        sortBy(key) {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
        this.tableFilter.column = key;
        this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
        this.getDataTable();
        },
        getIndex(array, key, value) {
        return array.findIndex((i) => i[key] == value);
        },
        deleteData(id) {
        let self = this;
        Swal.fire({
            title: "Perhatian",
            text: "Anda yakin ingin menghapus data tersebut?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `Iya`,
            denyButtonText: `Tidak`,
        }).then((result) => {
            if (result.isConfirmed) {
            self.loadingTable = true;
            Swal.fire({
                title: '<i class="fa fa-refresh fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
            });

            var config = {
                method: "delete",
                url:
                process.env.VUE_APP_BACKEND_URL_VERSION +
                "master/kategori-survei/" +
                id,
                headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config).then((response) => {
                var response_data = response.data;
                if (response_data.meta.code != "200") {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: response_data.data.message,
                });
                } else {
                Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: "Data berhasil dihapus.",
                    timer: 2000,
                    timerProgressBar: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                    self.getDataTable();
                    }
                });
                }
            });
            } else {
            Swal.close();
            }
        });
        },
        disable(row, status = null) {
        const label = status == 0 ? "menonaktifkan" : "mengaktifkan";

        // konfirmasi sebelum update status
        Swal.fire({
            icon: "question",
            title: `Apakah Anda yakin ingin ${label} data ini?`,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `Ya`,
            denyButtonText: `Tidak`,
        }).then(async (result) => {
            if (result.isConfirmed) {
            const data = await axios({
                method: "put",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "master/kategori-survei/" +
                    row.idkategori_survei + '/status',
                headers: {
                    Authorization: `Bearer ${localStorage.access_token}`,
                },
            })
                .then((response) => response.data)
                .catch((err) => {
                console.log("err update status:", err);
                Swal.fire({
                    icon: "error",
                    title: "Terjadi Kesalahan",
                    text: err.response.data.data,
                });
                return false;
                });
            if (data) {
                Swal.fire({
                icon: "success",
                title: "Status berhasil diperbarui",
                });
                this.getDataTable();
            }
            }
        });
        },
        toPage: function (url) {
        let link = new URLSearchParams(url);
        this.tableFilter.page = link.get("page");
        this.getDataTable(false); // Pass false to prevent resetting the page
        },
    },
    };
    </script>
    <template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
        <div class="col-lg-12">
            <div class="card">
            <div class="card-body">
                <div class="row">
                <div class="col-md-6">
                    <div class="card-title">Kategori Survei</div>
                </div>
                <div class="col-md-6">
                    <div class="text-end">
                    <button
                        v-on:click="showModalAdd = !showModalAdd"
                        class="btn btn-sm btn-success"
                    >
                        <i class="fa fa-plus"></i> Tambah
                    </button>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr />
                    <div class="row">
						<div class="form-group col-md-2">
							<label for="statusTable">Status</label>
							<select
							class="form-select"
							id="statusTable"
							v-model="tableFilter.filter_status"
							@change="getDataTable()"
							>
							<option selected value="1">ENABLE</option>
							<option value="0">DISABLE</option>
							</select>
						</div>
                    </div>
                    <hr />
                </div>
                <div class="col-md-12 mb-2">
                    <div class="row">
                    <div class="col-md-4">
                        <table>
                        <tr>
                            <td>Show</td>
                            <td>
                            <select
                                class="form-control form-control-sm"
                                id="showpaginatetable"
                                style="width: 100%"
                                v-model="tableFilter.per_page"
                                @change="getDataTable()"
                            >
                                <option value="10" selected>10</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                            </select>
                            </td>
                            <td>Entries</td>
                        </tr>
                        </table>
                    </div>
                    <div class="col-md-5">&nbsp;</div>
                    <div class="col-md-3">
                        <input
                        type="text"
                        class="form-control form-control-sm"
                        id="searchTable"
                        placeholder="Cari Data ..."
                        v-model="tableFilter.search"
                        @input="searchData()"
                        />
                    </div>
                    </div>
                </div>
                <datatable
                    :columns="columns"
                    :sortKey="sortKey"
                    :sortOrders="sortOrders"
                    @sort="sortBy"
                >
                    <tbody>
                    <tr v-if="loadingTable">
                        <td colspan="99" class="text-center">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                        </td>
                    </tr>
                    <tr v-else-if="table_data == ''">
                        <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                        </td>
                    </tr>
                    <tr
                        v-else
                        v-for="(row_data, key_data) in table_data"
                        :key="key_data"
                    >
                        <td class="text-center">
                        {{ pagination.from + key_data }}
                        </td>
                        <td>
                        {{ row_data?.kategori_aspek }}
                        </td>
                        <td>
                        {{ row_data?.deskripsi }}
                        </td>
						<td class="text-center">
							<button
                            type="button"
                            class="btn btn-warning btn-sm mx-2"
                            v-on:click="
								showModalEdit = !showModalEdit;
								selected_id = row_data.idkategori_survei;
                            "
							>
								<i class="fa fa-edit"></i> Edit
							</button>
                            <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-on:click="disable(row_data, 0)"
                            v-if="
                                row_data.active_flag != 0
                            "
                            >
                            <i class="fa fa-trash"></i> Disable
                            </button>
                            <button
                            type="button"
                            class="btn btn-success btn-sm"
                            v-on:click="disable(row_data)"
                            v-if="
                                row_data.active_flag == 0
                            "
                            >
                            <i class="fa fa-trash-restore"></i> Enable
                            </button>
                            <button
                            type="button"
                            class="btn btn-danger btn-sm mt-2"
                            v-on:click="deleteData(row_data.idkategori_survei)"
                            v-if="
                                row_data.active_flag == 0
                            "
                            >
                            <i class="fa fa-trash"></i> Hapus
                            </button>
						</td>
                    </tr>
                    </tbody>
                </datatable>
                </div>
                <pagination :pagination="pagination" @to-page="toPage"></pagination>
            </div>
            </div>
        </div>
        </div>
    </Layout>
    <b-modal v-model="showModalAdd" hide-footer title="Tambah Kategori Survei">
        <ModalAddKategoriSurvei @refresh="getDataTable" @close="showModalAdd = false" />
    </b-modal>
    <b-modal v-model="showModalEdit" hide-footer title="Edit Kategori Survei">
        <ModalEditKategoriSurvei @refresh="getDataTable" @close="showModalEdit = false" :id="selected_id" v-if="showModalEdit" />
    </b-modal>
</template>
